import * as React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from 'src/utils/shadcn';
import { Fragment } from 'react';

type Props = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    portal?: boolean;
};

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<React.ComponentRef<typeof PopoverPrimitive.Content>, Props>(
    ({ className, align = 'center', sideOffset = 4, portal = true, ...props }, ref) => {
        const Portal = portal ? PopoverPrimitive.Portal : Fragment;

        return (
            <Portal>
                <PopoverPrimitive.Content
                    ref={ref}
                    align={align}
                    sideOffset={sideOffset}
                    className={cn(
                        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border border-gray-200 bg-white p-4 text-gray-950 shadow-md outline-hidden dark:border-gray-800 dark:bg-gray-950 dark:text-gray-50',
                        className,
                    )}
                    onWheel={(e) => {
                        e.stopPropagation();
                    }}
                    onTouchMove={(e) => {
                        e.stopPropagation();
                    }}
                    {...props}
                />
            </Portal>
        );
    },
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
